import { createSearchParams } from 'react-router';

const createWizardCategoryUrl = () => ({
  pathname: routes.wizard,
  search: createSearchParams({
    stepName: 'categorySelect',
  }).toString(),
});

const createWizardFlavourUrl = (categoryId: string, flavourIds: string[]) => ({
  pathname: routes.wizard,
  search: createSearchParams({
    stepName: 'flavourSelect',
    category: categoryId,
    flavours: flavourIds.join(','),
  }).toString(),
});

const createWizardTasteUrl = (categoryId: string, flavourIds: string[], tasteIds: string[]) => ({
  pathname: routes.wizard,
  search: createSearchParams({
    stepName: 'tasteSelect',
    category: categoryId,
    flavours: flavourIds.join(','),
    tastes: tasteIds.join(','),
  }).toString(),
});

const createWizardMouthfeelUrl = (categoryId: string, flavourIds: string[], tasteIds: string[], mouthfeelIds: string[]) => ({
  pathname: routes.wizard,
  search: createSearchParams({
    stepName: 'mouthfeelSelect',
    category: categoryId,
    flavours: flavourIds.join(','),
    tastes: tasteIds.join(','),
    mouthfeels: mouthfeelIds.join(','),
  }).toString(),
});

const createResultsPageUrl = (categoryId: string, flavourIds: string[], tasteIds: string[], mouthfeelIds: string[]) => ({
  pathname: routes.results,
  search: createSearchParams({
    stepName: 'mouthfeelSelect',
    category: categoryId,
    flavours: flavourIds.join(','),
    tastes: tasteIds.join(','),
    mouthfeels: mouthfeelIds.join(','),
  }).toString(),
});

const routes = {
  wizard: '/wizard',
  results: '/results',

  createWizardCategoryUrl,
  createWizardFlavourUrl,
  createWizardTasteUrl,
  createWizardMouthfeelUrl,
  createResultsPageUrl,
};


export default routes;
